<arm-layout>
  <div header>
    <div class="search-container">
      <client-filter (onFilter)="onFilter($event)"></client-filter>
    </div>
    <div class="action-buttons">

      <arm-action-bar (deleteClick)="removeItem('selected')" [disableDelete]="isUnauthorized || emptySelection"
                      (refreshClick)="refresh()"></arm-action-bar>


        <button mat-raised-button class="more-actions" [matMenuTriggerFor]="menu" color="primary">
          <span>Actions</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="moveToCalls()" [disabled]="emptySelection">
            <span>View  calls</span>
          </button>

          <button mat-menu-item (click)="removeItem('all')" [disabled]="emptyCalls">
            <span>Delete all</span>
          </button>
        </mat-menu>

    </div>



  </div>

  <div main>
    <arm-table [data]="items" (onSelection)="select($event)"
               [displayedColumns]="displayedColumns" [isMultipleSelection]="true"
               [isClientSide]="true" [filter]="filter"></arm-table>
  </div>
</arm-layout>
